import { CustomJobAlertPage } from 'builder/components/FindJob/JobAlertPage/CustomJobAlertPage'

export const CustomJobAlertPageView = () => {
  return <CustomJobAlertPage />
}
